import apiRequestService from '@/commonProject/service/apiRequestService';

export default class HomeRepository {
    /**
     * メニュー情報取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMenuApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/mnudtl', requestBody, idToken);
        return result;
    }

    /**
     * 新着情報確認API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getArchiveCheckApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/arvchk', queryParam, idToken);
        return result;
    }

    /**
     * ユーザー状態確認(予約)APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async getUserStatusReserveActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/usrstsrsv', queryParam, idToken);
        return result;
    }
}
